import React from 'react';

export default function H2LinesST({data}) {

  return (
    <h2 className="center linesRed green initial homemadeTitle fs30">{data?.Titre}</h2>
  );
}
